import { render, staticRenderFns } from "./ownLease.vue?vue&type=template&id=4ebcbfbb&scoped=true&"
import script from "./ownLease.vue?vue&type=script&lang=js&"
export * from "./ownLease.vue?vue&type=script&lang=js&"
import style0 from "./ownLease.vue?vue&type=style&index=0&id=4ebcbfbb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebcbfbb",
  null
  
)

export default component.exports